import {
  CustomButton,
  CustomLabel,
  CustomWidth,
  FlexContainer,
  IStyleProps,
  NavHorizontalBar,
  SoftPurpleButton,
} from "@mindmemobile/mm-shared-global";
import styled from "styled-components";
import { NavpillContainer } from "./NavPills.styles";
import { CustomLine, MainOuterCard } from "./Layout.styles";
import { HalfContainer, SelectedColorButton } from "./CommonStyles";

export const ItemDetailsCard = styled.div`
  border: 1px solid #ccc;
  background-color: #fff;
  color: #000;
  padding: 20px 30px;
  border-radius: 10px;
  width: 536px;
  > ${FlexContainer} {
    ${CustomWidth} {
      &:first-child {
        width: 70%;
      }
      &:last-child {
        width: 30%;
        min-width: 140px;
      }
    }
    img {
      max-height: 90px;
      max-width: 140px;
      height: auto;
      width: auto;
      object-fit: cover;
      border-radius: 8px;
    }
    /* .add-on-image-container {
            height: auto;
            width: auto;
            max-height: 100%;
            max-width: 140px;
        } */
    .add-on-image {
      height: auto;
      width: auto;
      max-height: 100%;
      max-width: 140px;
      min-height: 80px;
      min-width: 120px;
      img {
        object-fit: cover;
        border-radius: 8px;
        max-height: 150px;
        max-width: 140px;
        height: auto;
        width: auto;
        /* height: 100%;
                width: 100%;
                 max-height: 100%;
                max-width: 100%; */ //creating issue, seems big image
      }
    }
  }
  .item-description {
    > ${CustomLabel} {
      &:first-child {
        font-size: 18px;
        font-weight: 600;
        color: #000;
      }
      &:nth-child(2) {
        font-size: 16px;
        font-weight: 400;
        margin: 12px 0px 24px;
      }
      &:last-child {
        font-size: 18px;
        font-weight: 400;
        margin-bottom: 35px;
      }
    }
  }
  button {
    font-size: 14px;
    font-weight: 600;
  }
  @media (max-width: 520px) {
    > ${FlexContainer} {
      flex-direction: column-reverse;
      flex-wrap: wrap;
      align-items: center;
      ${CustomWidth} {
        &:first-child {
          width: 100%;
        }
        &:last-child {
          width: 100%;
        }
      }
      .add-on-image {
        margin: 0 auto;
        max-height: 200px;
        max-width: 200px;
        img {
          height: auto;
          width: auto;
          /* max-height: 100%; */
          max-width: 100%;
        }
      }
      .text-right {
        text-align: center !important;
      }
      .btns-div {
        justify-content: center;
      }
    }
    .item-description {
      > ${CustomLabel} {
        white-space: unset;
      }
      pre {
        white-space: unset;
      }
    }
  }
  @media (min-width: 521px) and (max-width: 1200px) {
    > ${FlexContainer} {
      .add-on-image {
        margin: 0 auto;
        max-height: 200px;
        max-width: 200px;
        img {
          height: auto;
          width: auto;
          /* max-height: 100%; */
          max-width: 100%;
        }
      }
    }
  }
`;
// Common mediaquery component till 1200px and from 1201px-1400px
export const PurchaseColoredBackground = styled.div<IStyleProps>`
  background-color: ${(props) => props.outerColor || "#EEF8F3"};
  border: 1px solid ${(props) => props.outerBorder || "#ccc"};
  border-radius: 10px;
  padding: 50px 60px;
  width: 100%;
  height: 100%;
  .purchase-section {
    background-color: ${(props) => props.innerColor || "#fff"};
    border: 1px solid ${(props) => props.innerBorder || "#50b685"};
    border-radius: 10px;
    padding: ${(props) => props.padding || "50px 0px 50px 30px"};
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 30px;
    &::-webkit-scrollbar {
      width: 0.4em;
      height: 0.9em;
      background-color: #15283717;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      outline: 1px solid #ddd;
      background-color: rgb(170, 170, 170);
      border-radius: 10px;
    }
    > ${FlexContainer} {
      height: 100%;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 0.7em;
        height: 0.4em;
        background-color: #15283717;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        outline: 1px solid #ddd;
        background-color: rgba(21, 40, 55, 0.3);
        border-radius: 10px;
      }

      &.divided-component > div {
        width: 50%;
        &:first-child {
          display: flex;
          /* flex-direction: column; */
          gap: 20px;
          flex-wrap: wrap;
          img {
            &:first-child {
              min-width: 300px;
              width: 100%;
              height: 250px;
              object-fit: contain;
            }
            &:not(:first-child) {
              height: 55px;
              width: 80px;
            }
          }
        }
        &:last-child {
          /* width: 440px; */
          ${CustomLabel}:not(:first-child) {
            font-size: 18px;
            font-weight: 400;
          }
        }
        .item-right-panel {
          width: 440px;
          justify-content: center;
          margin-left: 13%;
          /* min-height: 280px;
                    justify-content: flex-start; */
        }
        ${SoftPurpleButton} {
          height: 50px;
          width: 200px;
          font-size: 22px;
        }
      }
    }
    > div.flex-auto-grow.purchase-confirmed {
      height: 100%;
      overflow-y: auto;
      > div {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 0px 30px;
        height: 100%;
        > div {
          width: 50%;
          
        }

        .item-right-panel {
          align-items: center;
          padding: 0px 20px;
        }
        &::-webkit-scrollbar {
          width: 0.4em;
          height: 0.4em;
          background-color: #15283717;
          border-radius: 10px;
        }
        &::-webkit-scrollbar-thumb {
          outline: 1px solid #ddd;
          background-color: rgba(21, 40, 55, 0.3);
          border-radius: 10px;
        }
      }
      &.purchase-chckout-preview {
            .purchase-data {
              width: auto;
              > div {
                width: auto;
              }
            }
          }
    }
    &.donation-purchase-section {
      padding: 0px !important;
      height: auto;
    }
    &.donation-pay-padding {
      padding: 50px 30px;
      .payment-price-wrapper {
        padding: 20px 0px;
        border-radius: 10px;
      }
    }
    &.donation-routes-purchase-section {
      // make changes only in actual rendering
      .purchase-confirmed {
        .option-carousel-wrapper {
          margin-bottom: 30px;
        }
      }
    }
    /* .payment-form {
            background: red;
            iframe div.chakra-tabs .chakra-tabs__tablist {
                padding-inline-start: 0px !important;
                padding-inline-end: 0px !important;
                button {
                    margin: 0px !important;
                }
            }
        } */
  }
  &.purchase-addon-screen {
    display: flex;
    flex-direction: column;
    gap: 40px;
    overflow-y: hidden;
    ${NavpillContainer} {
      margin-bottom: 10px;
    }
    ${ItemDetailsCard} {
      button {
        font-size: 14px;
        font-weight: 600;
        height: 30px;
        padding: 7px 5px;
        line-height: 12px;
        width: 80px;
        min-width: 80px;
        &.btn-without-border {
          border: none;
          background-color: #fff;
        }
      }
    }
    .purchase-main-btn {
      margin: 0px;
    }
    .addon-body-scroll {
      overflow-y: auto;
      height: calc(100% - 536px);
      width: 100%;
      &::-webkit-scrollbar {
        width: 0.4em;
        height: 0.4em;
        background-color: #15283717;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        outline: 1px solid #ddd;
        background-color: rgba(21, 40, 55, 0.3);
        border-radius: 10px;
      }
      > ${FlexContainer} {
        padding: 10px 50px 0px;
      }
    }
    .add-on-title {
      padding: 20px 0px;
    }
  }
  &.purchase-options-screen {
    .options-right-panel {
      /* padding: 0px 75px; */
    }
  }
  &.purchase-colored-donation-only {
    padding: 0px !important;
  }
  .item-header {
    font-size: 30px;
    font-weight: 600;
    line-height: 35px;
    word-break: break-word;
    &.purchase-dark-headers {
      color: #000;
      font-size: 22px;
      flex: 1 1 0;
    }
  }
  .desc-width {
    max-width: 49ch;
    word-break: break-word;
    width: inherit;
  }
  .price-special-info {
    font-weight: 600;
    color: #ff4242;
  }
  .options-main-image {
    height: auto;
    max-width: 487px;
    width: 70%;
  }
  .wrapped-columns {
    &.wrapped-width-auto {
      > div {
        width: 70%;
      }
      > .options-right-panel {
        max-width: 70%;
      }
    }
    > div {
      width: 50%;
      max-width: 600px;
      margin: 0 auto;
    }
  }
  .purchase-main-btn {
    margin: 40px 0px 0px;
    height: 40px;
    color: #fff;
    &.height-50 {
      height: 50px;
    }
    &.purchase-default-btn {
      min-width: 200px;
      font-size: 22px;
    }
  }
  ${SoftPurpleButton} {
    width: 150px;
    height: 40px;
  }
  .left-outer-card {
    .item-header {
      & + label {
        text-align: center;
        max-width: 37ch;
      }
    }
    label span {
      word-break: break-word;
    }
  }
  .item-right-panel {
    .major-price {
      font-size: 20px;
    }
    label span {
      word-break: break-word;
    }
  }
  &.colored-bg-with-image {
    padding: 0px;
    border-radius: 10px;
    &.purchase-section {
      padding: 0px !important;
      overflow-y: unset !important;
    }
  }

  /* Common mediaqueries till 1200px */
  @media (max-width: 1024px) {
    .wrapped-columns {
      flex-wrap: wrap;
      justify-content: center;
      gap: 20px !important;
      > div {
        width: 100%;
      }
    }
    .recommended-outer-card {
      width: auto !important;
      max-width: 600px;
    }
    .item-header {
      font-size: 24px;
      line-height: 30px;
      text-align: center;
      & + label {
        text-align: inherit;
      }
    }
    .left-outer-card {
      /* width: 80% !important; */
      max-width: 600px !important;
      justify-content: center;
      align-items: center;
      .item-header {
        & + label {
          text-align: inherit;
          max-width: 37ch;
        }
      }
    }
    .item-right-panel {
      padding: 0px;
      align-items: center;
      .recommended-outer-card {
        width: 80% !important;
        max-width: 600px;
        padding: 55px 15px 24px 15px !important;
        min-height: 160px;
        &.no-recommendations {
          padding: 24px 15px !important;
        }
        .item-header {
          font-size: 22px;
          line-height: 26px;
          text-align: left;
          & + label {
            text-align: inherit;
            font-size: 12px;
            line-height: 16px;
            width: 100%;
          }
        }
      }
    }
    .multiple-item-with-tab {
      ${MainOuterCard} {
        width: inherit;
        max-width: 280px;
        min-height: 200px;
        padding: 20px 25px !important;
      }
    }
    .desc-width {
      width: inherit;
    }
    ${CustomButton} {
      min-width: 80px;
    }
    .purchase-section {
      padding: 25px 15px !important;
      &.donation-purchase-section {
        height: inherit;
      }
      &.donation-routes-purchase-section {
        /* padding: 0px 0px 20px 0px !important; */
        padding: 0px !important;
      }
      > div.flex-auto-grow.purchase-confirmed {
        height: auto;
        overflow-y: unset;
        padding: 20px;
        gap: 50px;
        > div {
          flex-direction: column-reverse;
          gap: 40px;
          > div {
            width: 100%;
          }
        }
      }
    }
    .purchase-chckout-preview {
      .purchase-data {
        width: auto;
        > div {
          width: auto;
        }
      }
    }
    .attributes-alignment {
      justify-content: center;
    }
    &.purchase-addon-screen {
      .donation-routes-purchase-section {
        padding: 0px 0px 15px 0px !important;
      }
    }
  }
  @media (max-width: 768px) {
    .purchase-section {
      &.donation-routes-purchase-section {
        .donation-item-wrapper .donation-img-wrapper {
          padding: 0px !important;
        }
      }
    }
    .multiple-item-with-tab {
      ${MainOuterCard} {
        width: inherit;
        max-width: 280px;
        min-height: 200px;
        padding: 20px 25px !important;
      }
    }
    &.colored-bg-with-image {
      padding: 0px !important;
      border-radius: 10px;
    }
    &.purchase-addon-screen {
      .addon-body-scroll {
        > ${FlexContainer} {
          padding: 10px 0px 0px;
          justify-content: center;
        }
        .term-recurring {
          white-space: normal;
        }
      }
      .add-on-title {
        padding: 20px 5px;
      }
    }
  }
  @media (max-width: 1100px) {
    .divided-component {
      gap: 40px; // creating issue on zooming out
    }
    .item-right-panel {
      .recommended-outer-card {
        width: 100% !important;
        max-width: 600px;
        padding: 55px 24px 24px;
      }
    }
    .multiple-item-with-tab {
      ${MainOuterCard} {
        width: inherit;
        max-width: 340px;
        min-height: 200px;
        padding: 20px 25px !important;
      }
    }
  }
  @media (min-width: 1101px) and (max-width: 1200px) {
    .item-right-panel {
      .recommended-outer-card {
        padding: 55px 24px 24px;
      }
    }
  }

  /* Common mediaquery from 1201px-1400px  */
  @media (min-width: 1301px) and (max-width: 1550px) {
    .item-right-panel {
      .recommended-outer-card {
        max-width: 600px;
        width: auto;
      }
    }
  }
  @media (max-width: 768px) {
    border-radius: 0px;
    border-left: 0px;
    border-right: 0px;
    padding: 30px 25px;
  }
`;
export const CheckoutItemsWrapper = styled.div`
  background-color: #f4f7fb;
  border-radius: 10px;
  ${MainOuterCard} {
    padding: 45px 60px;
  }
  ${HalfContainer} {
    padding: 0px 20px;
    overflow-x: auto;
    width: calc(50% - 10px);
    /* border: 1px solid #ccc; */
    > div {
      min-width: 400px;
    }
    &::-webkit-scrollbar {
      width: 0.7em;
      height: 0.6em;
      background-color: #15283717;
      border-radius: 10px;
      cursor: pointer;
    }
    &::-webkit-scrollbar-thumb {
      outline: 1px solid #ddd;
      background-color: rgba(21, 40, 55, 0.3);
      border-radius: 10px;
      cursor: pointer;
    }
  }
  .product-item {
    justify-content: space-between;
    > img,
    video {
      min-height: 50px;
      height: auto;
      max-height: 80px;
      width: 60px;
      /* object-fit: fill; */
      //contain doesn't seems nice for horizontal images
      object-fit: contain;
      border-radius: 10px;
    }
    .product-description {
      /* margin: 0px 20px; */
      flex-direction: column;
      ${CustomLabel} {
        word-break: break-word;
        &:first-child {
          font-weight: 600;
          color: #000;
        }
        &:not(:first-child) {
          font-size: 10px;
          line-height: 14px;
          color: #aaa;
        }
      }
      .attribute-container {
        padding: 5px 0px 5px 5px;
        ${SelectedColorButton} {
          border: none;
        }
      }
    }
    .product-quantity {
      align-items: center;
      gap: 8px;
      img {
        height: 12px;
        width: 12px;
        cursor: pointer;
      }
      input {
        height: 20px;
        width: 35px;
        /* border: 1px solid #9bc9ff; */
        border: 1px solid #ccc;
        border-radius: 2px;
        background-color: #fff;
        font-size: 12px;
        line-height: 14px;
        font-weight: 400;
        text-align: center;
        color: #000;
      }
    }
  }
  .soft-text {
    font-size: 10px;
    line-height: 14px;
    color: #aaa;
    text-align: right;
  }
  .price-section {
    width: 150px;
  }
  .feedback-section {
    align-items: center;
    padding: 30px;
    gap: 25px;
    background-color: #f1fff8;
    border: 1px solid #7ecda6;
    border-radius: 10px;
    img {
      height: 96px;
      width: 96px;
      border-radius: 50%;
      object-fit: cover;
    }
    ${CustomLabel} {
      &:first-child {
        font-size: 14px;
        font-weight: 400;
      }
      &:last-child {
        font-size: 16px;
        font-weight: 600;
      }
    }
  }
  .guarantee-section {
    align-items: center;
    padding: 20px;
    gap: 25px;
    background-color: #f1f8ff;
    border: 1px solid #9bc9ff;
    border-radius: 10px;
    margin: 0px 0px 20px;
    img {
      height: 77px;
      width: 66px;
      border-radius: 50%;
      object-fit: contain;
    }
    ${CustomLabel} {
      &:first-child {
        font-size: 18px;
        font-weight: 700;
        color: #1976d2;
      }
      &:last-child {
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
  .payment-form {
    min-height: 150px;
    width: 100%;
    margin: 10px 0px;
  }
  .payment-form-input {
    .input-wrapper {
      width: 100%;
      > input {
        width: 100%;
        border: 1px solid #ccc;
      }
    }
    > div {
      width: 100%;
    }
    ${CustomLabel}:not(.sub-heading,.custom-label) {
      font-size: 10px;
      font-weight: 400;
      line-height: 14px;
      padding-left: 29px;
    }
    ${CustomLabel}.sub-heading {
      font-size: 16px;
      font-weight: 600;
      line-height: normal;
      margin: 10px 0px 0px;
      &.shipping-address {
        font-size: 16px;
        font-weight: 600;
      }
    }
    .terms-checkbox {
      display: flex;
      input {
        height: 17px;
        width: 17px;
        margin-top: 4px;
      }
    }
    .same-as-billing {
      padding-top: 10px;
      input {
        height: 17px;
        width: 17px;
        margin-top: 4px;
      }
    }

    .state-dpdn {
      width: 100%;
    }
    .header {
      width: inherit;
    }
  }
  .default-payment-method-form {
    padding: 0px !important;
  }
  .multiple-payment-method-form {
    padding: 0px 24px !important;
  }
  .pay-button {
    // background-color: #556bb8;
    width: 100%;
    padding: 10px 0px;
    height: auto;
    color: white;
    margin: 20px 0px;
    &.payment-main-btn {
      /* height: 40px; */
      font-size: 20px;
      border-radius: 8px;
      line-height: 24px;
      word-break: break-word;
    }
  }
  .bank-details-btn {
    width: 100%;
    padding: 20px;
    margin: 30px 0px;
    height: auto;
    color: black;
    background-color: gray;
    font-size: 20px;
    font-weight: 600;
    border-radius: 10px;
  }
  .feedback-at-bottom {
    display: none;
  }
  .card-descriptions {
    font-size: 10px;
    font-weight: 400;
    line-height: 15px;
    text-align: left;
    padding-left: 33px;
    margin: 20px 0px;
  }
  .card-icons img {
    height: 20px;
    width: 30px;
    object-fit: contain;
  }
  .dpdn-no-border {
    font-size: 12px;
    .header {
      padding-right: 0px;
    }
    .select-header-span {
      padding: 0px 0px 0px 6px;
    }
    .select-header-icon {
      transform: translate(0px, 0px);
    }
    .fa-solid {
      font-size: 12px;
    }
    .options-menu {
      font-size: 12px;
      line-height: 16px;
    }
  }
  .discounted-price {
    font-size: 16px;
    font-weight: 600;
    color: #000;
  }
  .payment-collapsed-panel {
    margin-bottom: 15px;
    > label,
    .collapsed-header-label {
      font-size: 15px;
      font-weight: 600;
    }
    i,
    .custom-collapsed-icon {
      font-size: 11px;
      color: #555;
      &.fa-chevron-right {
        margin-bottom: 0px;
        margin-top: 1px !important;
      }
      &.fa-chevron-left {
        margin-bottom: 5px !important;
      }
      &.fa-chevron-down {
        margin-top: 0px !important;
        margin-bottom: 2px !important;
      }
    }

    & + .no-border {
      width: inherit;
      padding: 0px 0px 0px 20px;
    }
  }
  .purchase-country-dropdown > div {
    /* min-width: 210px; */
    /* max-width: 250px; */
    width: inherit;
    .phone-data {
      font-size: 14px;
    }
    button {
      min-width: 50px;
      padding-right: 10px;
    }
    .input-wrapper > input {
      width: 100%;
      border: none;
    }
    .dropdown .dropdown-toggle label {
      padding-left: 0px !important;
    }
  }
  .divided-component.wrapped-columns {
    gap: 50px;
    justify-content: center;
  }
  .payment-collapsed-panel {
    & + .card {
      .card-body ${FlexContainer} ${CustomLabel} {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: #555;
      }
      ${CustomLine} {
        margin: 8px 0px;
      }
    }
    .fa-chevron-down,
    .fa-chevron-right {
      margin-left: 10px;
    }
  }
  .pay-button {
    /* width: auto; */
    width: 100% !important;
    padding: 10px 40px;
    margin: 15px auto 25px;
  }

  /* Media Queries are here!! */
  @media (min-width: 280px) and (max-width: 500px) {
    .feedback-section,
    .guarantee-section {
      flex-wrap: wrap;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      > ${FlexContainer} {
        align-items: center;
        label {
          text-align: center;
        }
      }
    }
    .payment-form-input {
      padding: 0px;
    }
  }
  .attribute-flex {
    display: flex;
    flex-wrap: wrap;
    gap: 0px;
  }
  @media (max-width: 1097px) {
    /* ${HalfContainer} {
            padding: 0px 20px;
            overflow-x: unset;
            width: 100%;
            > div {
                min-width: 400px;
            }
            .feedback-at-left {
                display: none;
            }
            .feedback-at-bottom {
                display: inline-block;
            }
        } */
    .styled-chkbox {
      display: flex;
    }
    .payment-collapsed-panel {
      & + .card {
        .card-body ${FlexContainer} ${CustomLabel} {
          font-size: 13px;
          font-weight: 600;
          line-height: 20px;
          color: #555;
        }
        ${CustomLine} {
          margin: 5px 0px;
        }
      }
      .fa-chevron-down,
      .fa-chevron-right {
        margin-left: 10px;
      }
    }
    .divided-component.wrapped-columns {
      gap: 30px;
    }
    .payment-form-input .sub-heading {
      font-size: 16px !important;
      line-height: normal;
    }
    .payment-collapsed-panel {
      i {
        &.fa-chevron-right {
          margin-bottom: 0px;
          margin-top: 0px;
        }
        &.fa-chevron-down {
          margin-bottom: 2px;
        }
      }
    }
  }
`;
/* Component with mediaqueries breakpoints  */
export const PurchaseWrapper = styled.div<IStyleProps>`
  background-color: ${(props) => props.bgColor};
  display: flex;
  padding: ${(props) => props.padding || "25px 70px"};
  flex-direction: column;
  gap: 20px;
  height: 100vh;
  .purchase-profile {
    img {
      height: 55px;
      width: 55px;
      border-radius: 50%;
    }
    ${FlexContainer} {
      align-items: center;
      gap: 20px;
    }
    ${CustomLabel} {
      font-size: 14px;
      font-weight: 600;
      line-height: 17px;
    }
  }
  .purchase-steps {
    ${FlexContainer} {
      align-items: center;
      justify-content: center;
      gap: 20px;
    }
    ${CustomLabel} {
      font-size: 22px;
      font-weight: 600;
      line-height: 26px;
      cursor: pointer;
      color: #555;
      &.active {
        color: #50b685;
      }
    }
    i {
      color: #555;
    }
  }
  .purchase-helpline {
    font-size: 14px;
    line-height: 20px;
    text-align: right;
    font-weight: 600;
  }
  .purchase-helpline-container {
    height: 55px;
    align-items: center;
  }
  .purchase-middle-panel {
    /* flex: 1 1 0; */ // This line is causing the issue on zooming out by taking the complete height of the screen.
    /* overflow-y: auto; */
    /* height: auto; */
    /* height: 100%;
        border: 1px solid #ccc;
        border-radius: 10px;
        height: calc(100% - 135px); */
    /* border: 1px solid #ccc; */
    border-radius: 10px;
    /* max-height: calc(100% - 135px); */
    max-height: calc(100% - 80px);
    // This line is causing the issue on zooming out by taking the complete height of the screen.
    /* height: 100vh; // might create issues on zooming out */

    /* latest changes */
    height: 100%;
    max-height: 100%;
    overflow-y: auto;
    flex: 1 1 0;

    ${PurchaseColoredBackground} {
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 0.5em;
        height: 0.4em;
        background-color: #15283717;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        outline: 1px solid #ddd;
        background-color: rgb(170, 170, 170);
        border-radius: 10px;
      }
    }
    &.middle-panel-with-topbar {
      max-height: calc(100% - 110px);
    }
    &.purchase-donation-topbar-middle {
      border-radius: 10px;
      .donation-ad-block {
        max-height: calc(100vh - 255px);
      }
      .donation-left-right-image {
        /* height: calc(100vh - 164px); */ // creating issue by leaving 15px upwards and 15px downwards
        height: calc(100vh - 130px);
      }
      .donation-img-bg-wrapper {
        /* height: calc(100vh - 164px); */ // creating issue by leaving 15px upwards and 15px downwards
        height: calc(100vh - 130px);
      }
    }
  }
  .purchase-steps-subtopbar {
    display: none;
    ${NavHorizontalBar} {
      height: 10px;
      width: 50px;
    }
  }
  ${SoftPurpleButton} {
    height: 50px;
    width: 200px;
    font-size: 22px;
  }
  .option-qty {
    input {
      height: 40px;
      width: 80px;
      text-align: center;
      border-radius: 4px;
      cursor: pointer;
    }
    img {
      cursor: pointer;
    }
  }
  .left-outer-card {
    label {
      text-align: center;
    }
  }
  .purchase-nav-flex {
    // min-height: 55px;
    /* Applied to stop fluctuation of height on/off profile and phone navpills, 
    but this is creating issue for all the other height given to donation-left-right-image   */
    > div {
      width: 300px;
    }
  }
  .wrapped-columns {
    &.wrapped-max-width {
      max-width: 1300px;
      margin: 0 auto;
      > div {
        max-width: 600px;
      }
    }
  }
  &.purchase-wrapper-donation-payment {
    padding: 0px;
    gap: 20px;
    div.purchase-middle-panel {
      > div,
      .purchase-section {
        padding: 0px !important;
      }
    }
    .donation-purchase-section {
      height: 100%;
    }
  }
  &.nav-flex-no-height {
    .donation-item-wrapper .donation-img-wrapper .donation-left-right-image {
      height: calc(100vh - 80px);
    }
  }

  /* Responsiveness for mobile screens */
  @media (max-width: 480px) {
    padding: 20px 0px;
    .purchase-profile {
      img {
        height: 30px;
        width: 30px;
      }
      ${CustomLabel} {
        font-size: 10px;
        line-height: 13px;
      }
      ${FlexContainer} {
        gap: 5px;
      }
    }
    .purchase-steps {
      display: none;
    }
    .purchase-helpline {
      font-size: 10px;
      line-height: 13px;
    }
    .purchase-steps-subtopbar {
      display: block;
      /* margin-bottom: 10px; */
      > ${FlexContainer} {
        justify-content: center;
        margin-top: 10px;
        .fa-chevron-right {
          margin-right: 10px;
        }
      }
      &.topbar-with-margin {
        margin-top: 10px;
      }
    }
    ${PurchaseColoredBackground} {
      padding: 30px 20px;
      border-radius: 0px;
    }
    .purchase-section {
      padding: 50px 15px;
      overflow-x: hidden;
    }
    .purchase-footer {
      font-size: 11px;
    }
    .divided-component.wrapped-columns {
      .left-outer-card {
        max-width: 100%;
      }
    }
    .purchase-middle-panel {
      /* max-height: calc(100% - 90px); */
      /* max-height: calc(100% - 176px); // creating issue for mobile screens */
      //might clear the issue of height for mobile screens
      max-height: calc(100% - 100px);
      border-radius: 0px;
      &.middle-panel-with-topbar {
        max-height: calc(100% - 120px);
      }
      ${PurchaseColoredBackground} {
        overflow-x: hidden;
      }
      &.purchase-donation-topbar-middle {
        > div {
          padding: 0px !important;
          &.purchase-options-screen .donation-routes-purchase-section {
            padding: 0px 0px 15px 0px !important;
          }
        }
        .donation-img-bg-wrapper {
          height: calc(100vh - 166px);
        }
      }
      &.purchase-donation-wo-topbar .donation-img-bg-wrapper {
        .donation-ad-block {
          &.bg-image-ad-block {
            max-height: calc(100vh - 250px) !important;
          }
        }
      }
    }
    .banner-text {
      font-size: 16px;
    }
    .purchase-options-screen {
      border-radius: 0px;
      padding: 0px 0px 15px 0px !important;
      .wrapped-columns {
        max-width: 300px;
        margin: 0 auto;
      }
      .option-carousel-wrapper {
        width: 100%;
        .carousel.slide {
          width: 100%;
          .carousel-item {
            text-align: center;
          }
        }
      }
      .options-right-panel {
        padding: 0px;
        label {
          text-align: center;
          width: 100%;
        }
      }
      .item-header + label {
        /* text-align: center; */
        text-align: inherit; //overrding the css for text editor
        width: 100%;
      }
    }
    .addon-body-scroll {
      overflow-x: hidden;
      ${ItemDetailsCard} {
        width: 250px;
      }
      > ${FlexContainer} {
        padding: 10px 20px 0px;
      }
    }
    ${CheckoutItemsWrapper} {
      ${MainOuterCard} {
        padding: 30px 15px;
      }
    }
    .purchase-nav-flex {
      padding: 0px 20px;
    }
    .option-qty {
      justify-content: center;
      input {
        width: 60px;
      }
    }
    &.purchase-wrapper-logo-help .donation-ad-block {
      max-height: calc(100vh - 130px) !important;
      max-height: calc(100vh - 145px) !important; //recent doubtfull changes
    }
  }
  /* Responsiveness for mobile screens */
  @media (min-width: 481px) and (max-width: 768px) {
    padding: 20px 0px;
    .purchase-profile {
      img {
        height: 30px;
        width: 30px;
      }
      ${FlexContainer} {
        gap: 5px;
      }
    }
    .purchase-middle-panel {
      border-radius: 0px;
      &.purchase-donation-topbar-middle {
        > div {
          padding: 0px !important;
          &.purchase-options-screen .donation-routes-purchase-section {
            padding: 0px 0px 15px 0px !important;
          }
        }
        .donation-img-bg-wrapper {
          height: calc(100vh - 176px);
        }
      }
    }
    .purchase-steps {
      display: none;
    }
    .purchase-steps-subtopbar {
      display: block;
      /* margin-bottom: 10px; */
      > ${FlexContainer} {
        justify-content: center;
        margin-top: 10px;
        .fa-chevron-right {
          margin-right: 10px;
        }
      }
      &.topbar-with-margin {
        margin-top: 10px;
      }
    }
    ${PurchaseColoredBackground} {
      padding: 30px 20px;
      border-radius: 0px;
    }
    .purchase-section {
      padding: 50px 15px;
    }
    .purchase-options-screen {
      border-radius: 0px;
      padding: 0px 0px 15px 0px !important;
      .wrapped-columns {
        width: 400px;
        margin: 0 auto;
      }
      .option-carousel-wrapper {
        width: 100%;
        .carousel.slide {
          width: 100%;
        }

        .carousel-item {
          text-align: center;
        }
      }
      .options-right-panel {
        padding: 0px;
        label {
          text-align: center;
          width: 100%;
        }
      }
    }
    .item-header + label {
      /* text-align: center; */
      text-align: inherit; //overrding the css for text editor
      width: 100%;
    }
    .addon-body-scroll {
      overflow-x: hidden;
      ${ItemDetailsCard} {
        width: 400px;
      }
      > ${FlexContainer} {
        padding: 10px 20px 0px !important;
      }
    }
    ${CheckoutItemsWrapper} {
      ${MainOuterCard} {
        padding: 30px 15px;
      }
    }

    .wrapped-columns {
      &.wrapped-max-width {
        max-width: 500px;
        margin: 0 auto;
      }
    }

    .purchase-nav-flex {
      padding: 0px 20px;
    }
    .option-qty {
      justify-content: center;
      input {
        width: 60px;
      }
    }
  }
  /* Responsiveness for mobile screens */
  @media (min-width: 769px) and (max-width: 1024px) {
    .purchase-options-screen {
      padding: 0px 0px 15px 0px !important;
      .wrapped-columns {
        width: 400px;
        margin: 0 auto;
      }
      .option-carousel-wrapper {
        width: 100%;
        .carousel.slide {
          width: 100%;
        }

        .carousel-item {
          text-align: center;
        }
      }
      .options-right-panel {
        padding: 0px;
        label {
          text-align: center;
          width: 100%;
        }
      }
    }
    .item-header + label {
      /* text-align: center; */
      text-align: inherit; //overrding the css for text editor
      width: 100%;
    }
    .addon-body-scroll {
      overflow-x: hidden;
      ${ItemDetailsCard} {
        width: 400px;
      }
    }
    ${CheckoutItemsWrapper} {
      ${MainOuterCard} {
        padding: 30px 15px;
      }
    }
    .wrapped-columns {
      &.wrapped-max-width {
        max-width: 500px;
        margin: 0 auto;
      }
    }
    .option-qty {
      justify-content: center;
      input {
        width: 60px;
      }
    }
  }
  /* Responsiveness for mobile screens */
  /* @media (min-width: 1025px) and (max-width: 1300px) {
        .purchase-options-screen {
            .wrapped-columns {
                width: 400px;
                margin: 0 auto;
            }
            .option-carousel-wrapper {
                width: 100%;
                .carousel.slide {
                    width: 100%;
                }
            }
            .options-right-panel {
                padding: 0px;
                label {
                    text-align: left;
                }
            }
        }
        .item-header + label {
            text-align: left;
        }
        .addon-body-scroll {
            overflow-x: hidden;
            ${ItemDetailsCard} {
                width: 100%;
                min-width: 400px;
            }
        }
        ${CheckoutItemsWrapper} {
            ${MainOuterCard} {
                padding: 30px 15px;
            }
        }
    } */
`;
export const FreeItemWrapper = styled.div<IStyleProps>`
  display: flex;
  gap: 10px;
  align-items: center;
  border: 1px solid #cccccc;
  padding: 20px;
  border-radius: 6px;
  background-color: #f8f8f8;
  margin: ${(props) => props.margin || "0px"};
  width: 400px;
  img {
    height: 40px;
    width: 40px;
    border-radius: 8px;
    object-fit: cover;
  }
  ${CustomLabel} {
    font-size: 16px;
    font-weight: 400;
  }
  @media (min-width: 200px) and (max-width: 480px) {
    width: 100%;
  }
`;
